module.exports = __webpack_public_path__ + "static/media/undraw_weather.ced53550.svg";